import { ArrowRight } from "lucide-react";
import FadeIn from "./FadeIn";
import { useLang } from "../../contexts/LanguageContext";

function renderEmphasis(text) {
  if (!text) return null;
  // Replace **bold** with <strong>bold</strong>
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <span key={i}>{part}</span>;
  });
}

export default function Statement({ content }) {
  const { t } = useLang();
  return (
    <section className="container-x py-24 md:py-32" data-testid="statement-section">
      <FadeIn>
        <div className="eyebrow mb-10" data-testid="statement-eyebrow">
          {t(content?.statement?.eyebrow)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <h2
            className="statement md:col-span-8 font-display font-semibold text-[#16181c] text-3xl sm:text-4xl md:text-5xl leading-[1.1]"
            data-testid="statement-headline"
          >
            {renderEmphasis(t(content?.statement?.headline))}
          </h2>
          <div className="md:col-span-4 md:pt-3 flex flex-col gap-6">
            <p className="text-[#5d5f64] text-base md:text-[17px] leading-relaxed">
              {t(content?.statement?.paragraph)}
            </p>
            <a
              href="#about"
              className="inline-flex items-center gap-2 text-[#16181c] font-medium border-b border-[#16181c] pb-1 w-fit hover:text-[#5d5f64] hover:border-[#5d5f64] transition-colors"
              data-testid="statement-link"
            >
              {t(content?.statement?.link_text)} <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </FadeIn>
    </section>
  );
}
